import { inject, Injectable } from '@angular/core';

import { Store } from '@ngrx/store';

import { IntelligenceAnalyticsActions } from '@core/intelligence-data';

@Injectable({
  providedIn: 'root',
})
export class IntelligenceAnalyticsService {
  private store = inject(Store);

  public track(event: string, data: { requestId: string; [k: string]: unknown }) {
    this.store.dispatch(IntelligenceAnalyticsActions.track({ payload: { event, data } }));
  }
}
